import React, { useRef } from 'react'
import DashboardLayout from '../layouts/DashboardLayout'
//import ourPhilosophy from '../assets/svg/our-philosophy.svg'
import ourPhilosophyimg from '../assets/svg/our-philosophy.svg'
import oneEco from '../assets/svg/one-eco.svg'
import longArrowDown from '../assets/svg/long-arrow-down.svg'
import encodeLogo from '../assets/svg/encode.svg'
import esriLogo from '../assets/esri-logo.png'
import EsriFooter from '../components/EsriFooter'

// import { Link } from "react-router-dom"
const About = props => {
    const ourPhilosophy = useRef()
    const whyViewpro = useRef()
    const partners = useRef()
    const scrollToEl = (e, ref) => {
        e.preventDefault()
        ref.current.scrollIntoView({ behavior: "smooth"});
    }
    return (
        <DashboardLayout hideAccountDropdown={true}>
            <div className="bg-primary-light bg-opacity-30 p-2 text-center border border-primary rounded-lg">

                <h2 className="text-xle font-bold mb-4">About Us</h2>
                <div>
                    <a href="#our-philosophy" onClick={(e) => scrollToEl(e, ourPhilosophy)} className="mx-3 xl:mx-8  hover:text-primary ">Our Philosophy</a>
                    <a href="#project-timeline" onClick={(e) => scrollToEl(e, whyViewpro)} className="mx-3 xl:mx-8 hover:text-primary">Why ViewPro?</a>
                    <a href="#partners" onClick={(e) => scrollToEl(e, partners)} className="mx-3 xl:mx-8 hover:text-primary">Our Partners</a>
                </div>
            </div>

            <div className="mt-16">

                <div className="pt-8" id="our-philosophy" ref={ourPhilosophy}>
                    <h2 className="text-xle font-bold mb-8">Our Philosophy</h2>
                    <div className="flex flex-col items-center mt-3 xl:mb-10 sm:mb-0">
                        <p className="text-xl xl:text-4xl font-bold mb-2 text-center">We build transformative cloud-based GIS solutions that simplify City Planning. </p>
                        <div className="w-3/6 sm:w-5/6"><p className="text-gray-500 text-xl text-center ">In collaboration with ESRI, we provide local governments with enhanced visibility into their data with the help of powerful yet simple-to-use GIS tools. </p></div>
                    </div>
                    <div className="xl:flex  sm:mt-10">
                        <div className=" flex flex-col items-center justify-center ml-16 xl:w-2/5 sm:w-5/6">
                            <p className="mb-4">We believe the foundation of a balanced city planning relies on three pillars - Zoning, Economic Development &amp; Citizen Engagement. To empower cities, we bring all its departmental geospatial needs under one platform and allow a real-time exchange of information between teams. Our platform further extends its reach by allowing users to integrate and utilize ESRI’s cutting-edge technology.</p>
                            <p>Allowing our users to leverage the power of data and team collaboration opportunities through a centralized platform, we provide cities with a 360° GIS solution – a one-stop-shop for all of their geospatial needs.</p>
                        </div>
                        <div className="w-3/5 flex xl:justify-center sm:mx-auto xl:mt-0 sm:mt-10">
                            <img src={ourPhilosophyimg} alt="" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="pt-12 mt-4" id="project-timeline " ref={whyViewpro}>
                <h2 className="text-xle font-bold mb-8">The ViewPro Advantage</h2>
                <p>As a certified ESRI partner, we help automate various local government workflows and bring more reliability, transparency, and clarity for the city officials and community at large.</p>
                <p>Our solutions are designed to enable inter-departmental data sharing and communication in a seamless and efficient manner. It enables and provides one ecosystem for all your city needs.</p>
                <div className="flex-wrap xl:flex-nowrap flex mt-8 justify-center xl:justify-between 3xl:justify-center xl:space-x-28">
                    <div className="w-83.5 mb-8  xl:mb-0">
                        <div className="flex items-center min-h-18">
                            <img src={oneEco} className="flex-shrink-0" alt="" />
                            <div className="ml-4">
                                <p><strong>One eco system</strong> for both ViewPro and Esri products.</p>
                            </div>
                        </div>
                        <div className="text-center flex justify-center py-2 ">
                            <img src={longArrowDown} alt="" />
                        </div>
                        <div className="px-5 text-center">
                            <p>Leverage your past &amp; current ESRI Assets and never let it go under utilized.</p>
                        </div>
                    </div>
                    <div className="w-83.5  mb-8  xl:mb-0">
                        <div className="flex items-center  min-h-18">
                            <img src={oneEco} className="flex-shrink-0" alt="" />
                            <div className="ml-4">
                                <p>Ongoing <strong>technical assistance support</strong> to ensure customer success.</p>
                            </div>
                        </div>
                        <div className="text-center flex justify-center py-2">
                            <img src={longArrowDown} alt="" />
                        </div>
                        <div className="px-5 text-center">
                            <p>Never let technical difficulties come in the way of your progress. Consider us your extended technical resource. </p>
                        </div>
                    </div>
                    <div className="w-83.5">
                        <div className="flex items-center  min-h-18">
                            <img src={oneEco} className="flex-shrink-0" alt="" />
                            <div className="ml-4">
                                <p>We are <strong>Urban Planners</strong> first! Your planning need is our priority. </p>
                            </div>
                        </div>
                        <div className="text-center flex justify-center py-2">
                            <img src={longArrowDown} alt="" />
                        </div>
                        <div className="px-5 text-center">
                            <p>Our tools are designed around your planning needs. We understand what matters the most to you. </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-12 pt-12" id="partners" ref={partners}>
                <h2 className="text-xle font-bold mb-8" >Partners</h2>
                <div className="flex justify-between flex-wrap xl:flex-nowrap text-sm text-center">
                    <div className="relative bg-primary-light rounded-lg border border-primary bg-opacity-30  pt-6 pb-10 px-6 xl:px-14 mb-4 xl:mb-0  w-full xl:w-2/4 xl:mr-4 flex flex-col items-center  3xl:min-h-99">
                        <img src={encodeLogo} alt="" />
                        <p className="mt-4 mb-4 max-w-132">
                            The partnership between enCodePlus municipal planning software and GIS platform developer ViewPro is a clear example of the whole equaling more than the sum of its parts. When you infuse the leading planning and zoning software in the industry with the inventive capabilities of the top online, interactive GIS platform integrator, you get a truly unmatched, fully integrated planning platform, destined to pioneer the way municipal planning is done in the future.
                        </p>
                        <div className="xl:absolute bottom-0 xl:mb-11 left-0 w-full">
                            <a href="https://www.encodeplus.com/" target="_blank" className="underline ">Visit enCodePlus &gt;</a>
                        </div>

                    </div>
                    <div className="relative bg-primary-light rounded-lg border border-primary bg-opacity-30 pt-6 pb-10 px-14  w-full xl:w-2/4 xl:ml-4 flex flex-col items-center  3xl:min-h-99">
                        <img src={esriLogo} alt="" />
                        <p className="mt-2 mb-4  max-w-132">
                            The partnership between enCodePlus municipal planning software and GIS platform developer ViewPro is a clear example of the whole equaling more than the sum of its parts. When you infuse the leading planning and zoning software in the industry with the inventive capabilities of the top online, interactive GIS platform integrator, you get a truly unmatched, fully integrated planning platform, destined to pioneer the way municipal planning is done in the future.
                        </p>
                        <div className="xl:absolute bottom-0 xl:mb-11 left-0 w-full">
                            <a href="https://www.esri.com/en-us/industries/state-local-government/overview" target="_blank" className="underline">Visit Esri</a>
                        </div>
                    </div>
                </div>
            </div>
            <div id="esri-encode" className="pt-8">
                <EsriFooter />
            </div>
        </DashboardLayout>
    )
}

export default About

